import {
  getFindAllTicketSalesASTEntityValuesQueryOptions,
  mapFindAllTicketSalesASTEntitiesResponseType,
  mapFindAllTicketSalesASTEntityValuesResponseType,
  useFindAllTicketSalesASTEntities,
} from '@api';
import { QueryBuilderEntityConfigType } from '@common';
import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';

type UseTicketSalesQueryEntitiesReturnType = QueryBuilderEntityConfigType[];

export const useTicketSalesQueryEntities =
  (): UseTicketSalesQueryEntitiesReturnType => {
    const queryClient = useQueryClient();

    const { data: astEntities = [] } = useFindAllTicketSalesASTEntities(
      { context: 'TICKET_SALES' },
      {
        query: {
          select: (data) => mapFindAllTicketSalesASTEntitiesResponseType(data),
        },
      }
    );

    return useMemo(
      () =>
        astEntities.map((entity) => ({
          key: entity.id,
          label: entity.label,
          color: entity.color,
          loadValues: async (_search: string) => {
            const response = await queryClient.ensureQueryData(
              getFindAllTicketSalesASTEntityValuesQueryOptions(entity.id)
            );
            return mapFindAllTicketSalesASTEntityValuesResponseType(response);
          },
        })),
      [astEntities, queryClient]
    );
  };
